// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore — no types for the wasm-bundle subpath
import libheif from 'libheif-js/wasm-bundle';

export async function heicToJpegBlob(file: File): Promise<Blob> {
  const buffer = await file.arrayBuffer();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const decoder = new (libheif as any).HeifDecoder();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const images: any[] = decoder.decode(new Uint8Array(buffer));

  if (!images || images.length === 0) {
    throw new Error('No images found in HEIC file');
  }

  const image = images[0];
  const width: number = image.get_width();
  const height: number = image.get_height();

  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;

  const ctx = canvas.getContext('2d')!;
  const imageData = ctx.createImageData(width, height);

  await new Promise<void>((resolve, reject) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    image.display(imageData, (displayData: any) => {
      if (!displayData) {
        reject(new Error('HEIF display error'));
        return;
      }
      resolve();
    });
  });

  ctx.putImageData(imageData, 0, 0);

  return new Promise<Blob>((resolve, reject) => {
    canvas.toBlob(
      blob =>
        blob ? resolve(blob) : reject(new Error('canvas.toBlob failed')),
      'image/jpeg',
      0.9,
    );
  });
}
